exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".importCard[data-v-7b8588eb]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.margin[data-v-7b8588eb]{margin:2px}.topicList[data-v-7b8588eb]{min-height:40px}.selectedTopic[data-v-7b8588eb]{background-color:#256;color:#fff}.pointer[data-v-7b8588eb]{cursor:pointer}.default[data-v-7b8588eb]{cursor:default}.width[data-v-7b8588eb]{width:100%}.fontSize[data-v-7b8588eb]{font-size:16px}.padTop[data-v-7b8588eb]{padding-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7b8588eb","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/ImportQuestions.vue
// module id = 418
// module chunks = 0